export default "__VITE_ASSET__C5jT2Jwq__"